import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import PropagateLoader from "react-spinners/PropagateLoader";
import Notifications, { notify } from "react-notify-toast";

class Login extends Component {
  //state = {  }

  constructor(props) {
    super(props);
    //  const api_token = localStorage.getItem('api_token')

    this.state = {
      username: "",
      password: "",
      loggedIn: false,
      loading: false,
    };

    //   let loggedIn = false

    //this.onChange = this.onChange.bind(this)
    // this.submitForm = this.submitForm.bind(this)
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  submitForm = (e) => {
    e.preventDefault();

    const { username, password } = this.state;

    let data = {
      usuario: username,
      password: password,
      remember_me: true,
    };

    this.setState({ loading: true });

    fetch("http://143.198.191.211/api/Login", {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.exito) {
          this.setState({ api_token: response.exito.api_token });
          localStorage.setItem("api_token", response.exito.api_token);
          //localStorage.setItem(Object.keys(response.exito),Object.values(response.exito))

          Object.keys(response.exito).forEach((element) => {
            // console.log(element+' ==> '+response.exito[element])
            localStorage.setItem(element, response.exito[element]);
          });

          this.setState({ loading: false });

          // this.setState({loggedIn:true})
          //     return (<Redirect to ='/documentos' />)
        } else {
          notify.show("E:" + response.error, "error", 2000);

          this.setState({ loading: false });
        }
      })
      .catch();
  };

  render() {
    if (localStorage.getItem("api_token")) {
      return <Redirect to="/escritorio" />;
    }
    return (
      <div className="login_body">
        <Notifications />

        <div className={this.state.loading ? "parentDisable" : ""} width="100%">
          <div className="overlay-box">
            <PropagateLoader
              // css={override}
              sizeUnit={"px"}
              size={25}
              color={"#000000"}
              loading={this.state.loading}
            />
          </div>
        </div>

        <div className="text-center">
          <div className="row">
            <div className="col-6">
              <img
                className="mb-4"
                src="img/logo_login_sgd.png"
                alt=""
                width="200"
              />
            </div>
            <div className="col-6">
              <img
                className="mb-4"
                src="img/logo_main_top.png"
                alt=""
                width="200"
              />
            </div>
          </div>

          <form className="form-signin" onSubmit={this.submitForm}>
            <h1 className="h3 mb-3 font-weight-normal">Acceso</h1>
            <label htmlFor="username" className="sr-only">
              Usuario
            </label>
            <input
              type="text"
              name="username"
              id="username"
              className="form-control"
              placeholder="Usuario"
              value={this.state.username}
              onChange={this.onChange}
              required
              autoFocus
            />
            <label htmlFor="password" className="sr-only">
              Contraseña
            </label>
            <input
              type="password"
              name="password"
              id="password"
              className="form-control"
              placeholder="Contraseña"
              value={this.state.password}
              onChange={this.onChange}
              required
            />
            <div className="checkbox mb-3">
              <label>
                <input type="checkbox" value="remember-me" /> Recordarme en este
                equipo
              </label>
            </div>
            <button className="btn btn-lg btn-primary btn-block" type="submit">
              Entrar
            </button>
            <p className="mt-5 mb-3 text-muted">
              &copy; H. XLI Ayuntamiento de Tepic 2020 administracionpublica.mx
            </p>
          </form>
        </div>
      </div>
    );
  }
}

export default Login;
